import * as Yup from 'yup'

export const initialCreateFormValues = {
    attribute_name: "",
    status: "",
}

export const createFormValidationSchema = Yup.object({
    attribute_name: Yup.string().required('This field is required'),
    status: Yup.string().required('This field is required'),
})
